import PropTypes from 'prop-types';

import styles from './PaginationCounter.module.scss';

export function PaginationCounter({ rowsPerPage, totalCount, page }) {
  function getCount() {
    if (!totalCount) return 0;
    if (rowsPerPage > totalCount) return totalCount;
    if ((page + 1) * rowsPerPage > totalCount) return totalCount % rowsPerPage;
    return rowsPerPage;
  }

  return (
    <div className={styles.paginationCounter}>
      <p>
        {totalCount ? (
          <>
            Showing <strong>{getCount()}</strong> of <strong>{totalCount}</strong>
          </>
        ) : (
          <>
            Showing <strong>0 results</strong>
          </>
        )}
      </p>
    </div>
  );
}

PaginationCounter.propTypes = {
  rowsPerPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
};
